import { StepWithResponseData } from 'hooks/activities/useQueryActivityAssignments';
import React, { useMemo } from 'react';
import { MediaGalleryFileInterface } from 'components/MediaGallery/MediaGallery';

export default function useActivityAssignmentStepDetails(stepWithResponse: StepWithResponseData): {
  mediaGalleryData: MediaGalleryFileInterface[];
} {
  const mediaGalleryData: MediaGalleryFileInterface[] = useMemo(() => {
    const filesToDisplay: MediaGalleryFileInterface[] = [];

    stepWithResponse.step.media?.forEach(
      (media, index) =>
        !!media.signedUrl &&
        filesToDisplay.push({
          url: media.signedUrl,
          index,
          fileType: media.fileType,
        })
    );

    const startIndex = filesToDisplay.length;

    stepWithResponse.response?.media?.forEach(
      (media, index) =>
        !!media.signedUrl &&
        filesToDisplay.push({
          url: media.signedUrl,
          index: startIndex + index,
          fileType: media.fileType,
        })
    );

    return filesToDisplay;
  }, [stepWithResponse.response?.media, stepWithResponse.step.media]);

  return {
    mediaGalleryData,
  };
}
